// @flow

import { useTranslator } from '@gandi/translate';
import { Badge } from '@gandi/ui';

import { useExtendedSuggestion } from './ProvidedArea/modules';

export function DomainDiscountPercentBadge({
  fqdn,
}: {
  fqdn: string,
}): null | React.MixedElement {
  const { formattedDiscount } = useExtendedSuggestion({
    fqdn,
  });
  if (!formattedDiscount) return null;
  return <DiscountPercentBadge formattedDiscount={formattedDiscount} />;
}

type ReturnExtendSuggestion = ReturnType<typeof useExtendedSuggestion>;
type Props = {
  formattedDiscount: $NonMaybeType<ReturnExtendSuggestion['formattedDiscount']>,
};
export function DiscountPercentBadge({
  formattedDiscount: { discountPercent, priceTenRatio },
}: Props): null | React.MixedElement {
  const { __ } = useTranslator();

  if (!discountPercent || !priceTenRatio) return null;

  return (
    <Badge intent="promotional">
      {/*  rebate, pricePercent are need to translate to all languages */}
      {__(
        '-%(discountPercent)s%%' +
          '<for-translators-use>discountPercent is percentage of normal price that taken by discount</for-translators-use>' +
          '<for-translators-use>priceTenRatio is the ratio between the discounted price and the normal price, expressed as a fraction of 10</for-translators-use>',
        { discountPercent, priceTenRatio },
      )}
    </Badge>
  );
}
